<!-- <div *ngIf="isVisible" [formGroup]="form">
  <ng-container [ngSwitch]="field.type">
    <div *ngSwitchCase="'text'">
      <div>
        <label class="kt-form-label font-medium text-xs mb-1">{{ config.label }}</label>
        <input [attr.type]="config.inputType || 'text'" [placeholder]="config.placeholder ?? ''"
          [formControlName]="config.name" class="kt-input" />

        <mat-error *ngIf="control?.invalid && control?.touched">
          Required
        </mat-error>
      </div>
    </div>

    <div *ngSwitchCase="'textarea'">
      <div>
        <label class="kt-form-label font-medium text-xs mb-1">{{ config.label }}</label>
        <textarea [name]="config.name" [placeholder]="config.placeholder ?? ''" [formControlName]="config.name"
          class="kt-input h-auto min-h-[4rem] resize-y" rows="2">
        </textarea>
      </div>
    </div>

    <div *ngSwitchCase="'date'">
      <div>
        <label class="kt-form-label font-medium text-xs mb-1">{{ config.label }}</label>
        <input [attr.type]="config.inputType || 'text'" [placeholder]="config.placeholder ?? ''"
          [formControlName]="config.name" class="kt-input" />
      </div>
    </div>

    <div *ngSwitchCase="'checkbox'" class="bg-slate-50 border border-slate-300 rounded px-2 py-1">
      <div>
        <label class="kt-form-label font-medium text-xs mb-1">{{ config.label }}</label>
        <input [attr.type]="config.inputType || 'checkbox'" [formControlName]="config.name" class="kt-input" />
      </div>
    </div>

    <div *ngSwitchCase="'select'">
      <div>
        <label class="kt-form-label font-medium text-xs mb-1">{{ config.label }}</label>
        <select [formControlName]="config.name" class="kt-input">
          <option value="">-- Select --</option>
          <option *ngFor="let o of field.options" [value]="o.value">
            {{ o.label }}
          </option>
        </select>
      </div>
    </div>

    <div *ngSwitchCase="'autocomplete'">
      <label class="kt-form-label font-medium text-xs mb-1">
        {{ config.label }}
      </label>

      <sw-dynamic-autocomplete [config]="config" [label]="config.label" [placeholder]="config.placeholder || ''"
        [api]="config.dataSource?.api || ''" [valueField]="config.dataSource?.valueField || 'id'"
        [labelField]="config.dataSource?.labelField || 'name'" [minLength]="config.dataSource?.minLength || 2"
        [ngModel]="control?.value" (ngModelChange)="control?.setValue($event)" [ngModelOptions]="{standalone: true}">
      </sw-dynamic-autocomplete>

      <mat-error *ngIf="control?.invalid && control?.touched">
        Required
      </mat-error>
    </div>
  </ng-container>
</div> -->

<div *ngIf="isVisible">

  <app-field-host
    [field]="config"
    [form]="form"
    [row]="row">
  </app-field-host>

</div>